module.exports = __webpack_public_path__ + "img/icon_sgyl.36cfa5d4.png";